export default "__VITE_ASSET__7c5dfec1__"